/*
  Festegiatu - fg-seating.js
  Sitzplan-Planer (Tischplaner), version 1.
  Se monta sobre fg-core.js. Estado en localStorage bajo festegiatu_event_v1.

  Alcance v1 (Achraf, 12.09.2026):
  - Setup en 3 pasos, plano con mesas movibles, asignacion de invitados,
    guardado local, captura de email con el formulario nativo de Shopify.
  - Sin upsells (no hay catalogo todavia).
  - Sin cuenta de cliente ni backend: el plan vive en este navegador.

  Accesibilidad tactil: arrastrar mesas tiene alternativa por toques
  (seleccionar mesa, pulsar "Verschieben", tocar el sitio del plano).

  14.09.2026, festegiatu-shopify-dev: el modal "Sitzplan sichern" ya no crea
  su propio formulario ni su propio input de email. Usa el mismo <form>
  nativo que pinta snippets/fg-lead-form.liquid (nodo leadFormNode, mas
  abajo), lo mueve dentro de la caja del modal con appendChild y lo devuelve
  a su sitio cuando no hace falta. Es el mismo nodo del DOM en todo momento:
  nunca se clona ni se sustituye. Vease fg-core.js y fg-lead-form.liquid para
  el porque (el formulario oculto de antes rompia el filtro antispam de
  Shopify). Ademas, por decision de Achraf del 14.09.2026, imprimir ya no es
  posible sin haber dejado antes el email: el boton "Plan drucken" solo
  aparece cuando FG.leadCaptured.get() es true.
*/
(function () {
  'use strict';

  var FG = window.FG;
  if (!FG) return;

  var root = document.getElementById('fg-sitzplan');
  if (!root) return;

  /* El formulario de email vive fuera de #fg-sitzplan (lo pinta el snippet
     fg-lead-form.liquid como hermano de este contenedor). Se guarda la
     referencia una vez: aunque root.innerHTML se reescriba en cada render(),
     este nodo puede volver a colocarse donde haga falta con appendChild,
     porque appendChild mueve un nodo existente, no lo clona. */
  var leadFormNode = document.getElementById('fg-lead-holder');

  /* El plano no tiene tamano fijo: se calcula a partir de cuantas mesas hay y
     del hueco real que ocupa cada una con su corona de sillas. Con un tamano
     fijo, a partir de 8 mesas las sillas de una mesa caian encima de la mesa
     de al lado. */
  var FLOOR_MIN_W = 760;
  var FLOOR_MIN_H = 520;
  var SEAT_OFFSET = 24;
  var SEAT_R = 15;
  var MARGIN = 20;

  var KINDS = {
    round: { label: 'Rund', note: 'Klassisch, gute Gespräche', w: 120, h: 120, round: true, max: 12 },
    rect: { label: 'Eckig', note: 'Platzsparend im Saal', w: 150, h: 110, round: false, max: 10 },
    long: { label: 'Lange Tafel', note: 'Gemeinsam an einem Tisch', w: 270, h: 90, round: false, max: 14 },
    head: { label: 'Brauttisch', note: 'Vorne im Saal', w: 300, h: 90, round: false, max: 8 }
  };

  var LAYOUTS = [
    { id: 'grid', label: 'Raster' },
    { id: 'rows', label: 'Reihen' },
    { id: 'u', label: 'U-Form' },
    { id: 'circle', label: 'Kreis' }
  ];

  var GUEST_PRESETS = [40, 60, 80, 120];

  /* Impresion. Medidas en mm, ancho x alto en vertical. El formato 50x70 no
     tiene nombre CSS, por eso @page se escribe siempre con milimetros
     explicitos y nunca con A4/A3. */
  var PRINT_FORMATS = [
    { id: 'a4', label: 'A4', w: 210, h: 297 },
    { id: 'a3', label: 'A3', w: 297, h: 420 },
    { id: 'a2', label: 'A2', w: 420, h: 594 },
    { id: 'a1', label: 'A1', w: 594, h: 841 },
    { id: 'p5070', label: '50 × 70 cm', w: 500, h: 700 }
  ];
  var PRINT_MARGIN_MM = 10;
  var PRINT_HEAD_MM = 24;
  var MM_TO_PX = 96 / 25.4;

  var S = null;

  /* ---------------------------------------------------------------- estado */

  function defaults() {
    return {
      step: 'setup',
      setupStep: 1,
      guests: 80,
      tableCount: 10,
      wantHead: true,
      kind: 'round',
      seatsPerTable: 8,
      layout: 'grid',
      tables: [],
      seatMap: {},
      guestList: [],
      floorW: FLOOR_MIN_W,
      floorH: FLOOR_MIN_H,
      printFormat: 'a3',
      printOrient: 'landscape',
      printList: false
    };
  }

  function load() {
    var saved = FG.read().sitzplan;
    var base = defaults();
    if (saved && typeof saved === 'object') {
      for (var k in base) {
        if (Object.prototype.hasOwnProperty.call(saved, k)) base[k] = saved[k];
      }
    }
    base.selected = null;
    base.picked = null;
    base.moveArmed = false;
    base.confirmRemove = false;
    base.exportOpen = false;
    base.printOpen = false;
    base.justConfirmed = false;
    base.zoom = 1;
    base.draft = '';
    return base;
  }

  function writeNow() {
    FG.write({
      sitzplan: snapshot()
    });
  }

  function snapshot() {
    return {
      step: S.step,
      setupStep: S.setupStep,
      guests: S.guests,
      tableCount: S.tableCount,
      wantHead: S.wantHead,
      kind: S.kind,
      seatsPerTable: S.seatsPerTable,
      layout: S.layout,
      tables: S.tables,
      seatMap: S.seatMap,
      guestList: S.guestList,
      floorW: S.floorW,
      floorH: S.floorH,
      printFormat: S.printFormat,
      printOrient: S.printOrient,
      printList: S.printList
    };
  }

  var persist = FG.debounce(writeNow, 250);

  function commit() {
    persist();
    render();
  }

  /* ------------------------------------------------------------ generacion */

  function buildTables() {
    var list = [];
    var n = clampNum(S.tableCount, 1, 40);
    for (var i = 0; i < n; i++) {
      list.push({
        id: FG.uid('t'),
        name: 'Tisch ' + (i + 1),
        kind: S.kind,
        seats: clampNum(S.seatsPerTable, 2, KINDS[S.kind].max),
        head: false,
        x: 0,
        y: 0
      });
    }
    if (S.wantHead) {
      list.unshift({
        id: FG.uid('t'),
        name: 'Brauttisch',
        kind: 'head',
        seats: 2,
        head: true,
        x: 0,
        y: 0
      });
    }
    S.tables = list;
    S.seatMap = {};
    for (var j = 0; j < list.length; j++) S.seatMap[list[j].id] = fillSeats(list[j].seats, []);
    applyLayout(S.layout);
  }

  function fillSeats(n, prev) {
    var out = [];
    for (var i = 0; i < n; i++) out.push(prev && prev[i] !== undefined ? prev[i] : null);
    return out;
  }

  /* Radio que ocupa de verdad una mesa: la mesa, mas la distancia a la que
     salen las sillas, mas el radio de la silla, mas un poco de aire. */
  function footprint(t) {
    var k = KINDS[t.kind] || KINDS.round;
    return Math.max(k.w, k.h) / 2 + SEAT_OFFSET + SEAT_R + 12;
  }

  function maxFootprint(list) {
    return list.reduce(function (m, t) { return Math.max(m, footprint(t)); }, 70);
  }

  function applyLayout(id) {
    S.layout = id;
    var guests = S.tables.filter(function (t) { return !t.head; });
    var head = S.tables.filter(function (t) { return t.head; });
    var n = guests.length;
    var fp = maxFootprint(guests.length ? guests : S.tables);
    var cell = fp * 2 + 8;
    var headBand = head.length ? footprint(head[0]) * 2 + 16 : 0;
    var w, h, cols, rows, i;

    if (id === 'circle' && n > 1) {
      /* Radio minimo para que dos mesas contiguas del anillo no se toquen. */
      var ring = Math.max(cell, (cell / 2) / Math.sin(Math.PI / n));
      w = Math.max(FLOOR_MIN_W, (ring + fp + MARGIN) * 2);
      h = Math.max(FLOOR_MIN_H, headBand + (ring + fp + MARGIN) * 2);
      var cx = w / 2, cy = headBand + (h - headBand) / 2;
      guests.forEach(function (t, j) {
        var a = (Math.PI * 2 * j) / n - Math.PI / 2;
        t.x = cx + Math.cos(a) * ring;
        t.y = cy + Math.sin(a) * ring;
      });
    } else if (id === 'u' && n > 2) {
      var side = Math.max(1, Math.floor((n - 1) / 2));
      var rest = n - side * 2;
      w = Math.max(FLOOR_MIN_W, (Math.max(rest, 1) + 2) * cell + MARGIN * 2);
      h = Math.max(FLOOR_MIN_H, headBand + (side + 1) * cell + MARGIN * 2);
      var left = MARGIN + fp, right = w - MARGIN - fp;
      guests.forEach(function (t, j) {
        if (j < side) {
          t.x = left;
          t.y = headBand + MARGIN + fp + j * cell;
        } else if (j < side * 2) {
          t.x = right;
          t.y = headBand + MARGIN + fp + (j - side) * cell;
        } else {
          var k2 = j - side * 2;
          t.x = left + cell + (k2 + 0.5) * ((right - left - cell * 2) / Math.max(rest, 1)) + cell / 2;
          t.y = h - MARGIN - fp;
        }
      });
    } else {
      if (id === 'rows') cols = Math.max(1, Math.ceil(n / 3));
      else cols = Math.max(1, Math.ceil(Math.sqrt(n * 1.3)));
      rows = Math.max(1, Math.ceil(n / cols));
      w = Math.max(FLOOR_MIN_W, cols * cell + MARGIN * 2);
      h = Math.max(FLOOR_MIN_H, headBand + rows * cell + MARGIN * 2);
      guests.forEach(function (t, j) {
        var r2 = Math.floor(j / cols), c2 = j % cols;
        /* La ultima fila se centra si va incompleta. */
        var inRow = Math.min(cols, n - r2 * cols);
        var rowW = inRow * cell;
        t.x = (w - rowW) / 2 + (c2 + 0.5) * cell;
        t.y = headBand + MARGIN + (r2 + 0.5) * cell;
      });
    }

    S.floorW = Math.round(w);
    S.floorH = Math.round(h);
    head.forEach(function (t) { t.x = S.floorW / 2; t.y = headBand / 2 + 8; });
    S.tables.forEach(clampTable);
  }


  function clampTable(t) {
    var fp = footprint(t);
    t.x = clampNum(t.x, fp, Math.max(fp, S.floorW - fp));
    t.y = clampNum(t.y, fp, Math.max(fp, S.floorH - fp));
  }

  function clampNum(v, lo, hi) {
    v = Number(v);
    if (isNaN(v)) v = lo;
    return Math.max(lo, Math.min(hi, Math.round(v)));
  }

  /* -------------------------------------------------------------- invitados */

  function seatedIds() {
    var out = {};
    for (var id in S.seatMap) {
      S.seatMap[id].forEach(function (g) { if (g) out[g] = true; });
    }
    return out;
  }

  function pool() {
    var taken = seatedIds();
    return S.guestList.filter(function (g) { return !taken[g.id]; });
  }

  function guestById(id) {
    for (var i = 0; i < S.guestList.length; i++) if (S.guestList[i].id === id) return S.guestList[i];
    return null;
  }

  function capacity() {
    return S.tables.reduce(function (a, t) { return a + t.seats; }, 0);
  }

  function shortName(name) {
    var parts = String(name).trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2);
    return (parts[0][0] || '') + (parts[1][0] || '');
  }

  /* ---------------------------------------------------------------- helpers */

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (k === 'class') n.className = attrs[k];
        else if (k === 'text') n.textContent = attrs[k];
        else if (k === 'html') n.innerHTML = attrs[k];
        else if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') n.addEventListener(k.slice(2), attrs[k]);
        else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) n.setAttribute(k, attrs[k]);
      }
    }
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }

  function btn(label, cls, onClick, attrs) {
    var a = attrs || {};
    if (!a.type) a.type = 'button';
    a.class = cls;
    a.onclick = onClick;
    a.text = label;
    return el('button', a);
  }

  /* ----------------------------------------------------------------- setup */

  var SETUP = [
    {
      title: 'Wie viele Gäste feiern mit euch?',
      help: 'Eine ungefähre Zahl reicht. Ihr könnt sie später jederzeit ändern.'
    },
    {
      title: 'Wie viele Tische stehen im Saal?',
      help: 'Wir schlagen euch eine Zahl vor. Passt sie an das an, was euer Saal hergibt.'
    },
    {
      title: 'Wie sehen eure Tische aus?',
      help: 'Form, Plätze und die grobe Anordnung im Raum. Alles bleibt später änderbar.'
    }
  ];

  function suggestTables() {
    var perTable = clampNum(S.seatsPerTable, 2, 14);
    var guestsWithoutHead = S.wantHead ? Math.max(0, S.guests - 2) : S.guests;
    return Math.max(1, Math.ceil(guestsWithoutHead / perTable));
  }

  function renderSetup() {
    var i = S.setupStep - 1;
    var body = [];

    if (S.setupStep === 1) {
      body.push(
        el('div', { class: 'fg-sp__stepper' }, [
          btn('−', 'fg-sp__round', function () { S.guests = clampNum(S.guests - 5, 2, 400); commit(); }, { 'aria-label': 'Weniger Gäste' }),
          el('input', {
            type: 'number', min: 2, max: 400, value: S.guests, class: 'fg-sp__bignum',
            'aria-label': 'Anzahl Gäste',
            onchange: function (e) { S.guests = clampNum(e.target.value, 2, 400); commit(); }
          }),
          btn('+', 'fg-sp__round', function () { S.guests = clampNum(S.guests + 5, 2, 400); commit(); }, { 'aria-label': 'Mehr Gäste' }),
          el('span', { class: 'fg-sp__muted', text: 'Gäste inklusive euch beiden' })
        ]),
        el('div', { class: 'fg-sp__chips' }, GUEST_PRESETS.map(function (p) {
          return btn(String(p), 'fg-sp__chip' + (S.guests === p ? ' is-on' : ''), function () { S.guests = p; commit(); });
        }))
      );
    }

    if (S.setupStep === 2) {
      body.push(
        el('div', { class: 'fg-sp__stepper' }, [
          btn('−', 'fg-sp__round', function () { S.tableCount = clampNum(S.tableCount - 1, 1, 40); commit(); }, { 'aria-label': 'Weniger Tische' }),
          el('input', {
            type: 'number', min: 1, max: 40, value: S.tableCount, class: 'fg-sp__bignum',
            'aria-label': 'Anzahl Tische',
            onchange: function (e) { S.tableCount = clampNum(e.target.value, 1, 40); commit(); }
          }),
          btn('+', 'fg-sp__round', function () { S.tableCount = clampNum(S.tableCount + 1, 1, 40); commit(); }, { 'aria-label': 'Mehr Tische' }),
          el('span', { class: 'fg-sp__muted', text: 'Gästetische' })
        ]),
        el('div', {
          class: 'fg-sp__hint',
          text: 'Bei ' + S.guests + ' Gästen und ' + S.seatsPerTable + ' Plätzen pro Tisch schlagen wir ' + suggestTables() + ' Gästetische vor.'
        }),
        el('label', { class: 'fg-sp__check' }, [
          el('input', {
            type: 'checkbox', checked: S.wantHead ? 'checked' : null,
            onchange: function (e) { S.wantHead = e.target.checked; commit(); }
          }),
          el('span', {}, [
            el('span', { class: 'fg-sp__check-title', text: 'Eigener Brauttisch' }),
            el('span', { class: 'fg-sp__muted', text: 'Kommt zusätzlich, vorne im Saal.' })
          ])
        ])
      );
    }

    if (S.setupStep === 3) {
      body.push(
        el('div', { class: 'fg-sp__field' }, [
          el('div', { class: 'fg-sp__legend', text: 'Tischform' }),
          el('div', { class: 'fg-sp__kinds' }, ['round', 'rect', 'long'].map(function (k) {
            return el('button', {
              type: 'button', class: 'fg-sp__kind' + (S.kind === k ? ' is-on' : ''),
              onclick: function () { S.kind = k; S.seatsPerTable = clampNum(S.seatsPerTable, 2, KINDS[k].max); commit(); }
            }, [
              el('span', { class: 'fg-sp__kind-icon fg-sp__kind-icon--' + k }),
              el('span', {}, [
                el('span', { class: 'fg-sp__check-title', text: KINDS[k].label }),
                el('span', { class: 'fg-sp__muted', text: KINDS[k].note })
              ])
            ]);
          }))
        ]),
        (function () {
          var live = el('strong', { text: String(S.seatsPerTable) });
          return el('label', { class: 'fg-sp__field' }, [
            el('span', { class: 'fg-sp__legend fg-sp__legend--row' }, [
              el('span', { text: 'Plätze pro Tisch' }),
              live
            ]),
            el('input', {
              type: 'range', min: 2, max: KINDS[S.kind].max, step: 1, value: S.seatsPerTable, class: 'fg-sp__range',
              /* oninput no re-renderiza: si lo hace, el slider se destruye a
                 mitad de gesto y en movil el arrastre se corta. */
              oninput: function (e) {
                S.seatsPerTable = clampNum(e.target.value, 2, KINDS[S.kind].max);
                live.textContent = String(S.seatsPerTable);
              },
              onchange: function () { commit(); }
            })
          ]);
        })(),
        el('div', { class: 'fg-sp__field' }, [
          el('div', { class: 'fg-sp__legend', text: 'Anordnung im Saal' }),
          el('div', { class: 'fg-sp__chips' }, LAYOUTS.map(function (l) {
            return btn(l.label, 'fg-sp__chip' + (S.layout === l.id ? ' is-on' : ''), function () { S.layout = l.id; commit(); });
          }))
        ]),
        el('div', {
          class: 'fg-sp__hint',
          text: S.tableCount + ' Tische × ' + S.seatsPerTable + ' Plätze' + (S.wantHead ? ' + Brauttisch' : '') +
            ' ergeben ' + (S.tableCount * S.seatsPerTable + (S.wantHead ? 2 : 0)) + ' Plätze für ' + S.guests + ' Gäste.'
        })
      );
    }

    var actions = [];
    if (S.setupStep > 1) actions.push(btn('Zurück', 'fg-sp__btn fg-sp__btn--ghost', function () { S.setupStep--; commit(); }));
    actions.push(btn(
      S.setupStep === 3 ? 'Plan erstellen' : 'Weiter',
      'fg-sp__btn fg-sp__btn--primary fg-sp__btn--grow',
      function () {
        if (S.setupStep === 1) { S.tableCount = suggestTables(); S.setupStep = 2; commit(); return; }
        if (S.setupStep === 2) { S.setupStep = 3; commit(); return; }
        buildTables();
        S.step = 'arrange';
        FG.track('sitzplan_created', { guests: S.guests, tables: S.tables.length });
        commit();
      }
    ));

    return el('div', { class: 'fg-sp__setup' }, [
      el('section', { class: 'fg-sp__card' }, [
        el('div', {}, [
          el('div', { class: 'fg-sp__kicker', text: 'Schritt ' + S.setupStep + ' von 3' }),
          el('h1', { class: 'fg-sp__h1', text: SETUP[i].title }),
          el('p', { class: 'fg-sp__lede', text: SETUP[i].help })
        ])
      ].concat(body).concat([el('div', { class: 'fg-sp__actions' }, actions)]))
    ]);
  }

  /* ------------------------------------------------------------------ plano */

  function seatPositions(t) {
    var k = KINDS[t.kind] || KINDS.round;
    var out = [];
    var i;
    if (k.round) {
      var r = k.w / 2 + 24;
      for (i = 0; i < t.seats; i++) {
        var a = (Math.PI * 2 * i) / t.seats - Math.PI / 2;
        out.push({ x: Math.cos(a) * r, y: Math.sin(a) * r });
      }
    } else {
      var top = Math.ceil(t.seats / 2), bottom = t.seats - top;
      for (i = 0; i < top; i++) {
        out.push({ x: ((i + 1) * k.w) / (top + 1) - k.w / 2, y: -(k.h / 2 + 24) });
      }
      for (i = 0; i < bottom; i++) {
        out.push({ x: ((i + 1) * k.w) / (bottom + 1) - k.w / 2, y: k.h / 2 + 24 });
      }
    }
    return out;
  }

  function renderFloor() {
    var floor = el('div', { class: 'fg-sp__floor', style: 'width:' + S.floorW + 'px;height:' + S.floorH + 'px;transform:scale(' + S.zoom + ')' }, [
      el('div', { class: 'fg-sp__stage-label', text: 'Bühne / Tanzfläche' })
    ]);

    floor.addEventListener('pointerdown', function (e) {
      if (!S.moveArmed || !S.selected) return;
      if (e.target !== floor && !e.target.classList.contains('fg-sp__stage-label')) return;
      var rect = floor.getBoundingClientRect();
      var t = tableById(S.selected);
      if (!t) return;
      t.x = (e.clientX - rect.left) / S.zoom;
      t.y = (e.clientY - rect.top) / S.zoom;
      clampTable(t);
      S.moveArmed = false;
      commit();
    });

    S.tables.forEach(function (t) {
      var k = KINDS[t.kind] || KINDS.round;
      var seats = S.seatMap[t.id] || [];
      var used = seats.filter(function (g) { return !!g; }).length;

      var shape = el('div', {
        class: 'fg-sp__table' + (t.head ? ' is-head' : '') + (S.selected === t.id ? ' is-sel' : '') + (k.round ? ' is-round' : ''),
        style: 'width:' + k.w + 'px;height:' + k.h + 'px',
        role: 'button',
        tabindex: '0',
        'aria-label': t.name
      }, [
        el('span', { class: 'fg-sp__table-kind', text: k.label }),
        el('span', { class: 'fg-sp__table-name', text: t.name }),
        el('span', { class: 'fg-sp__table-fill', text: used + '/' + t.seats })
      ]);

      shape.addEventListener('click', function () {
        if (S.selected === t.id && !S.confirmRemove) return;
        S.selected = t.id;
        S.confirmRemove = false;
        render();
      });
      shape.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); S.selected = t.id; render(); }
      });
      if (S.step === 'arrange') attachDrag(shape, t, floor);

      var wrap = el('div', { class: 'fg-sp__slot', style: 'left:' + t.x + 'px;top:' + t.y + 'px' }, [shape]);

      seatPositions(t).forEach(function (p, idx) {
        var gid = seats[idx];
        var g = gid ? guestById(gid) : null;
        var seat = el('button', {
          type: 'button',
          class: 'fg-sp__seat' + (g ? ' is-taken' : '') + (S.picked && !g ? ' is-open' : ''),
          style: 'left:' + p.x + 'px;top:' + p.y + 'px',
          title: g ? g.name : 'Freier Platz',
          text: g ? shortName(g.name) : '',
          onclick: function (e) { e.stopPropagation(); onSeat(t, idx); }
        });
        wrap.appendChild(seat);
      });

      floor.appendChild(wrap);
    });

    /* El scale() no cambia el tamano de maquetacion, asi que sin este
       contenedor el area de scroll del escenario seguiria siendo 1000x720
       y al ampliar se cortaria el plano. */
    return el('div', {
      class: 'fg-sp__canvas',
      style: 'width:' + Math.round(S.floorW * S.zoom) + 'px;height:' + Math.round(S.floorH * S.zoom) + 'px'
    }, [floor]);
  }

  function tableById(id) {
    for (var i = 0; i < S.tables.length; i++) if (S.tables[i].id === id) return S.tables[i];
    return null;
  }

  function attachDrag(node, t, floor) {
    var moving = false, ox = 0, oy = 0, moved = false;
    node.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      moving = true; moved = false;
      var rect = floor.getBoundingClientRect();
      ox = (e.clientX - rect.left) / S.zoom - t.x;
      oy = (e.clientY - rect.top) / S.zoom - t.y;
      node.setPointerCapture(e.pointerId);
      node.classList.add('is-drag');
    });
    node.addEventListener('pointermove', function (e) {
      if (!moving) return;
      var rect = floor.getBoundingClientRect();
      t.x = (e.clientX - rect.left) / S.zoom - ox;
      t.y = (e.clientY - rect.top) / S.zoom - oy;
      clampTable(t);
      moved = true;
      node.parentNode.style.left = t.x + 'px';
      node.parentNode.style.top = t.y + 'px';
    });
    function end(e) {
      if (!moving) return;
      moving = false;
      node.classList.remove('is-drag');
      try { node.releasePointerCapture(e.pointerId); } catch (err) {}
      if (moved) { S.selected = t.id; commit(); }
    }
    node.addEventListener('pointerup', end);
    node.addEventListener('pointercancel', end);
  }

  function onSeat(t, idx) {
    var seats = S.seatMap[t.id];
    if (!seats) return;
    var current = seats[idx];
    if (S.picked) {
      for (var id in S.seatMap) {
        var arr = S.seatMap[id];
        for (var i = 0; i < arr.length; i++) if (arr[i] === S.picked) arr[i] = null;
      }
      seats[idx] = S.picked;
      S.picked = null;
    } else if (current) {
      seats[idx] = null;
    } else {
      S.selected = t.id;
    }
    commit();
  }

  /* ------------------------------------------------------------ panel lateral */

  function renderSidePanel() {
    var kids = [];
    var t = S.selected ? tableById(S.selected) : null;

    if (t) {
      kids.push(el('div', { class: 'fg-sp__panel-block' }, [
        el('div', { class: 'fg-sp__panel-head' }, [
          el('h2', { class: 'fg-sp__h2', text: t.name }),
          btn('Löschen', 'fg-sp__mini', function () { S.confirmRemove = true; render(); })
        ]),
        S.confirmRemove ? el('div', { class: 'fg-sp__confirm' }, [
          el('p', { text: 'Soll ' + t.name + ' wirklich weg? Die Gäste von diesem Tisch gehen zurück in die Liste.' }),
          el('div', { class: 'fg-sp__confirm-row' }, [
            btn('Ja, Tisch löschen', 'fg-sp__btn fg-sp__btn--danger', function () {
              S.tables = S.tables.filter(function (x) { return x.id !== t.id; });
              delete S.seatMap[t.id];
              S.selected = null;
              S.confirmRemove = false;
              commit();
            }),
            btn('Abbrechen', 'fg-sp__btn fg-sp__btn--ghost', function () { S.confirmRemove = false; render(); })
          ])
        ]) : null,
        el('div', { class: 'fg-sp__grid2' }, [
          el('label', { class: 'fg-sp__small' }, [
            el('span', { text: 'Name / Nummer' }),
            el('input', {
              class: 'fg-sp__input', value: t.name, maxlength: '18',
              onchange: function (e) { t.name = e.target.value.slice(0, 18) || t.name; commit(); }
            })
          ]),
          el('label', { class: 'fg-sp__small' }, [
            el('span', { text: 'Form' }),
            (function () {
              var sel = el('select', {
                class: 'fg-sp__input',
                onchange: function (e) {
                  t.kind = e.target.value;
                  t.head = t.kind === 'head';
                  t.seats = clampNum(t.seats, 2, KINDS[t.kind].max);
                  S.seatMap[t.id] = fillSeats(t.seats, S.seatMap[t.id]);
                  clampTable(t);
                  commit();
                }
              });
              ['round', 'rect', 'long', 'head'].forEach(function (k) {
                var o = el('option', { value: k, text: KINDS[k].label });
                if (t.kind === k) o.selected = true;
                sel.appendChild(o);
              });
              return sel;
            })()
          ])
        ]),
        (function () {
          var live = el('strong', { text: String(t.seats) });
          return el('label', { class: 'fg-sp__small' }, [
            el('span', { class: 'fg-sp__legend--row' }, [el('span', { text: 'Plätze' }), live]),
            el('input', {
              type: 'range', min: 2, max: KINDS[t.kind].max, step: 1, value: t.seats, class: 'fg-sp__range',
              oninput: function (e) {
                t.seats = clampNum(e.target.value, 2, KINDS[t.kind].max);
                live.textContent = String(t.seats);
              },
              onchange: function () {
                S.seatMap[t.id] = fillSeats(t.seats, S.seatMap[t.id]);
                commit();
              }
            })
          ]);
        })()
      ]));

      if (S.step === 'arrange') {
        kids.push(el('div', { class: 'fg-sp__panel-block' }, [
          btn(S.moveArmed ? 'Jetzt Stelle antippen' : 'Verschieben',
            'fg-sp__btn ' + (S.moveArmed ? 'fg-sp__btn--primary' : 'fg-sp__btn--ghost'),
            function () { S.moveArmed = !S.moveArmed; render(); }),
          el('p', { class: 'fg-sp__muted', text: 'Zieht die Tische an ihren Platz. Auf dem Handy: Tisch antippen, "Verschieben" wählen, dann die Stelle im Plan antippen.' })
        ]));
      }
    }

    if (S.step === 'arrange') {
      kids.push(el('div', { class: 'fg-sp__panel-block' }, [
        el('div', { class: 'fg-sp__panel-title', text: 'Tische' }),
        btn('+ Tisch hinzufügen', 'fg-sp__btn fg-sp__btn--dashed', function () {
          var t2 = { id: FG.uid('t'), name: 'Tisch ' + (S.tables.length + 1), kind: S.kind, seats: S.seatsPerTable, head: false, x: S.floorW / 2, y: S.floorH / 2 };
          S.tables.push(t2);
          S.seatMap[t2.id] = fillSeats(t2.seats, []);
          S.selected = t2.id;
          commit();
        }),
        el('div', { class: 'fg-sp__chips' }, LAYOUTS.map(function (l) {
          return btn(l.label, 'fg-sp__chip' + (S.layout === l.id ? ' is-on' : ''), function () { applyLayout(l.id); commit(); });
        }))
      ]));
    }

    if (S.step === 'seating') kids.push(renderGuests());

    return el('aside', { class: 'fg-sp__side' }, kids);
  }

  function renderGuests() {
    var p = pool();
    var block = el('div', { class: 'fg-sp__panel-block' }, [
      el('div', { class: 'fg-sp__panel-head' }, [
        el('h2', { class: 'fg-sp__h2', text: 'Gästeliste' }),
        el('span', { class: 'fg-sp__muted', text: p.length + ' ohne Platz' })
      ])
    ]);

    var form = el('form', { class: 'fg-sp__addrow' }, [
      el('input', {
        class: 'fg-sp__input', placeholder: 'Name eingeben', 'aria-label': 'Gastname', value: S.draft,
        oninput: function (e) { S.draft = e.target.value; }
      }),
      btn('+', 'fg-sp__round fg-sp__round--solid', null, { type: 'submit', 'aria-label': 'Gast hinzufügen' })
    ]);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = String(S.draft || '').trim();
      if (!name) return;
      name.split(/[,;\n]/).forEach(function (piece) {
        var nm = piece.trim();
        if (nm) S.guestList.push({ id: FG.uid('g'), name: nm.slice(0, 40) });
      });
      S.draft = '';
      commit();
    });
    block.appendChild(form);

    block.appendChild(el('div', { class: 'fg-sp__chips' }, p.map(function (g) {
      return el('button', {
        type: 'button',
        class: 'fg-sp__chip fg-sp__chip--guest' + (S.picked === g.id ? ' is-on' : ''),
        text: g.name,
        onclick: function () { S.picked = S.picked === g.id ? null : g.id; render(); }
      });
    })));

    block.appendChild(el('p', {
      class: 'fg-sp__muted',
      text: S.picked ? 'Jetzt einen freien Platz im Plan antippen.' : 'Namen antippen, dann einen freien Platz im Plan wählen. Mehrere Namen auf einmal: mit Komma trennen.'
    }));

    var list = el('div', { class: 'fg-sp__panel-block' }, [
      el('div', { class: 'fg-sp__panel-head' }, [
        el('h2', { class: 'fg-sp__h2', text: 'Sitzliste' }),
        el('span', { class: 'fg-sp__muted', text: (S.guestList.length - p.length) + ' Gäste' })
      ])
    ]);

    S.tables.forEach(function (t) {
      var seats = S.seatMap[t.id] || [];
      var used = seats.filter(function (g) { return !!g; }).length;
      var ol = el('ol', { class: 'fg-sp__seatlist' });
      seats.forEach(function (gid, i) {
        var g = gid ? guestById(gid) : null;
        ol.appendChild(el('li', { class: g ? '' : 'is-empty' }, [
          el('span', { class: 'fg-sp__seatnum', text: String(i + 1) }),
          el('span', { text: g ? g.name : 'frei' })
        ]));
      });
      list.appendChild(el('div', { class: 'fg-sp__tableblock' }, [
        el('button', {
          type: 'button', class: 'fg-sp__tablehead',
          onclick: function () { S.selected = t.id; render(); },
          'aria-label': t.name + ', ' + used + ' von ' + t.seats + ' Plätzen belegt'
        }, [
          el('span', { class: 'fg-sp__tablename', text: t.name }),
          el('span', { class: 'fg-sp__tablecount', text: used + '/' + t.seats })
        ]),
        ol
      ]));
    });

    return el('div', {}, [block, list]);
  }

  /* ---------------------------------------------------------------- guardar */

  function renderExport() {
    if (!S.exportOpen) return null;
    var p = pool();
    var summary = S.tables.length + ' Tische, ' + (S.guestList.length - p.length) + ' von ' + S.guestList.length + ' Gästen haben einen Platz.';
    var captured = FG.leadCaptured.get();

    var kids = [
      el('div', { class: 'fg-sp__panel-head' }, [
        el('h2', { class: 'fg-sp__h1', text: 'Sitzplan sichern' }),
        btn('×', 'fg-sp__round', function () { S.exportOpen = false; render(); }, { 'aria-label': 'Schließen' })
      ]),
      el('p', { class: 'fg-sp__lede', text: summary + ' Euer Plan liegt in diesem Browser und bleibt hier gespeichert, auch wenn ihr die Seite schließt.' })
    ];

    /* 14.09.2026, decision de Achraf: sin email no hay impresion. Si ya se
       dejo el email antes (leadCaptured en festegiatu_event_v1), se salta
       directo al atajo de imprimir; si no, lo que se ve aqui es el
       formulario real (leadFormNode), no un atajo alrededor de el. */
    if (captured) {
      kids.push(el('p', { class: 'fg-sp__note', text: 'Ihr seid bereits eingetragen. Der Plan ist druckbereit.' }));
      kids.push(el('div', { class: 'fg-sp__confirm-row' }, [
        btn('Plan drucken', 'fg-sp__btn fg-sp__btn--dark', function () { S.exportOpen = false; S.printOpen = true; FG.track('sitzplan_print_open', {}); render(); }),
        btn('Weiter planen', 'fg-sp__btn fg-sp__btn--ghost', function () { S.exportOpen = false; render(); })
      ]));
    } else {
      kids.push(el('p', { class: 'fg-sp__note', text: 'Trag deine E-Mail-Adresse ein: danach bekommt ihr die Druckoptionen.' }));
      if (leadFormNode) kids.push(leadFormNode);
      kids.push(el('div', { class: 'fg-sp__confirm-row' }, [
        btn('Weiter planen', 'fg-sp__btn fg-sp__btn--ghost', function () { S.exportOpen = false; render(); })
      ]));
    }

    var box = el('div', { class: 'fg-sp__modal-box' }, kids);
    var overlay = el('div', { class: 'fg-sp__modal' }, [box]);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) { S.exportOpen = false; render(); } });
    return overlay;
  }

  /* --------------------------------------------------------------- drucken */

  function printFormat() {
    for (var i = 0; i < PRINT_FORMATS.length; i++) {
      if (PRINT_FORMATS[i].id === S.printFormat) return PRINT_FORMATS[i];
    }
    return PRINT_FORMATS[1];
  }

  /* Devuelve el papel ya girado: en horizontal se intercambian los lados. */
  function printPageMm() {
    var f = printFormat();
    if (S.printOrient === 'landscape') return { w: f.h, h: f.w };
    return { w: f.w, h: f.h };
  }

  /* Escala para que el plano llene el papel util, reservando alto para la
     cabecera impresa.

     13.09.2026: antes esto tenia tope 1, o sea nunca ampliaba. Con eso, elegir
     A2 o A1 daba el mismo plano pequeno que A4, centrado en una hoja enorme,
     que es justo lo contrario de lo que se quiere: un Sitzplan de boda se
     imprime grande para leerse desde lejos en el salon. Ahora se amplia hasta
     llenar la hoja. Como el plano es DOM (texto y bordes, no una imagen), al
     ampliarlo no pierde definicion. El tope alto es solo un seguro. */
  function printScale() {
    var mm = printPageMm();
    var usableW = (mm.w - PRINT_MARGIN_MM * 2) * MM_TO_PX;
    var usableH = (mm.h - PRINT_MARGIN_MM * 2 - PRINT_HEAD_MM) * MM_TO_PX;
    var w = S.floorW || FLOOR_MIN_W;
    var h = S.floorH || FLOOR_MIN_H;
    var sc = Math.min(usableW / w, usableH / h);
    if (!(sc > 0)) sc = 1;
    return Math.min(6, sc);
  }

  function printSummary() {
    var mm = printPageMm();
    var pct = Math.round(printScale() * 100);
    return 'Der Plan wird auf ' + mm.w + ' × ' + mm.h + ' mm gedruckt, Maßstab ' + pct + ' %.';
  }

  function doPrint() {
    var mm = printPageMm();
    var tag = document.getElementById('fg-print-page');
    if (!tag) {
      tag = document.createElement('style');
      tag.id = 'fg-print-page';
      document.head.appendChild(tag);
    }
    tag.textContent = '@page{size:' + mm.w + 'mm ' + mm.h + 'mm;margin:' + PRINT_MARGIN_MM + 'mm}';
    root.style.setProperty('--fg-print-scale', String(Math.round(printScale() * 1000) / 1000));
    root.style.setProperty('--fg-floor-w', (S.floorW || FLOOR_MIN_W) + 'px');
    root.style.setProperty('--fg-floor-h', (S.floorH || FLOOR_MIN_H) + 'px');
    S.printOpen = false;
    persist();
    render();
    FG.track('sitzplan_print', { format: S.printFormat, orient: S.printOrient, list: S.printList });
    window.print();
  }

  function renderPrint() {
    if (!S.printOpen) return null;
    /* La confirmacion solo se ensena la primera vez que se abre este modal
       tras un envio de email recien hecho, no en cada click de formato u
       orientacion (que tambien llaman a render()). */
    var justNow = !!S.justConfirmed;
    S.justConfirmed = false;
    var info = el('p', { class: 'fg-sp__lede', text: printSummary() });
    var touch = 'min-height:var(--fg-touch-min)';

    function refresh() {
      info.textContent = printSummary();
      persist();
    }

    var formats = el('div', { class: 'fg-sp__chips' }, PRINT_FORMATS.map(function (f) {
      return btn(f.label, 'fg-sp__chip' + (S.printFormat === f.id ? ' is-on' : ''), function () {
        S.printFormat = f.id;
        refresh();
        render();
      }, { style: touch, 'aria-pressed': S.printFormat === f.id ? 'true' : 'false' });
    }));

    var orients = el('div', { class: 'fg-sp__chips' }, [
      { id: 'portrait', label: 'Hochformat' },
      { id: 'landscape', label: 'Querformat' }
    ].map(function (o) {
      return btn(o.label, 'fg-sp__chip' + (S.printOrient === o.id ? ' is-on' : ''), function () {
        S.printOrient = o.id;
        refresh();
        render();
      }, { style: touch, 'aria-pressed': S.printOrient === o.id ? 'true' : 'false' });
    }));

    var listBox = el('input', { type: 'checkbox' });
    listBox.checked = !!S.printList;
    listBox.addEventListener('change', function () {
      S.printList = listBox.checked;
      persist();
    });

    var headKids = [
      el('h2', { class: 'fg-sp__h1', text: 'Plan drucken' }),
      btn('×', 'fg-sp__round', function () { S.printOpen = false; render(); }, { 'aria-label': 'Schließen' })
    ];

    var boxKids = [el('div', { class: 'fg-sp__panel-head' }, headKids)];
    if (justNow) boxKids.push(el('p', { class: 'fg-sp__flash', text: 'Eingetragen. Hier sind eure Druckoptionen.' }));
    boxKids.push(
      el('p', { class: 'fg-sp__lede', text: 'Sagt uns, wie groß euer Plan werden soll. Wir richten ihn passend auf dem Blatt aus.' }),
      el('div', { class: 'fg-sp__field' }, [
        el('span', { class: 'fg-sp__legend', text: 'Format' }),
        formats
      ]),
      el('div', { class: 'fg-sp__field' }, [
        el('span', { class: 'fg-sp__legend', text: 'Ausrichtung' }),
        orients
      ]),
      el('label', { class: 'fg-sp__check' }, [
        listBox,
        el('span', {}, [
          el('span', { class: 'fg-sp__check-title', text: 'Gästeliste nach Tischen mitdrucken' }),
          el('span', { class: 'fg-sp__muted', text: 'Kommt auf eine eigene Seite hinter den Plan.' })
        ])
      ]),
      info,
      el('p', { class: 'fg-sp__note', text: 'Im Druckfenster eures Browsers könnt ihr statt eines Druckers "Als PDF speichern" wählen. So bekommt ihr den Plan als PDF.' }),
      el('div', { class: 'fg-sp__confirm-row' }, [
        btn('Jetzt drucken', 'fg-sp__btn fg-sp__btn--dark', doPrint),
        btn('Abbrechen', 'fg-sp__btn fg-sp__btn--ghost', function () { S.printOpen = false; render(); })
      ])
    );

    var box = el('div', { class: 'fg-sp__modal-box' }, boxKids);

    var overlay = el('div', { class: 'fg-sp__modal' }, [box]);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) { S.printOpen = false; render(); } });
    return overlay;
  }

  /* Cabecera y lista solo salen en papel: nacen ocultas con style en linea y
     fg-sitzplan-print.css las muestra dentro de @media print. Asi el bloque
     <style> de la seccion no crece. */
  function renderPrintHead() {
    var p = pool();
    var seated = S.guestList.length - p.length;
    return el('div', { class: 'fg-sp__printhead', style: 'display:none' }, [
      el('h2', { class: 'fg-sp__h1', text: 'Sitzplan' }),
      el('p', { class: 'fg-sp__note', text: S.tables.length + ' Tische, ' + seated + ' von ' + S.guestList.length + ' Gästen haben einen Platz.' })
    ]);
  }

  function renderPrintList() {
    if (!S.printList) return null;
    var cols = el('div', { class: 'fg-sp__printlist-cols' });
    var wrap = el('section', { class: 'fg-sp__printlist', style: 'display:none' }, [
      el('h2', { class: 'fg-sp__h1', text: 'Gäste nach Tisch' }),
      cols
    ]);
    S.tables.forEach(function (t) {
      var seats = S.seatMap[t.id] || [];
      var used = seats.filter(function (g) { return !!g; }).length;
      var ol = el('ol', { class: 'fg-sp__seatlist' });
      seats.forEach(function (gid, i) {
        var g = gid ? guestById(gid) : null;
        ol.appendChild(el('li', { class: g ? '' : 'is-empty' }, [
          el('span', { class: 'fg-sp__seatnum', text: String(i + 1) }),
          el('span', { text: g ? g.name : 'frei' })
        ]));
      });
      cols.appendChild(el('div', { class: 'fg-sp__tableblock' }, [
        el('div', { class: 'fg-sp__panel-title' }, [
          el('span', { class: 'fg-sp__tablename', text: t.name }),
          el('span', { class: 'fg-sp__tablecount', text: used + '/' + t.seats })
        ]),
        ol
      ]));
    });
    return wrap;
  }

  /* ---------------------------------------------------------------- render */

  function renderPlan() {
    var main = el('section', { class: 'fg-sp__card fg-sp__card--stage' }, [
      el('div', { class: 'fg-sp__panel-head' }, [
        el('h1', { class: 'fg-sp__h1', text: S.step === 'arrange' ? 'Stellt euren Saal' : 'Setzt eure Gäste' }),
        el('span', { class: 'fg-sp__muted', text: S.step === 'arrange' ? 'Tische an ihren Platz bringen' : 'Name antippen, Platz antippen' })
      ]),
      el('div', { class: 'fg-sp__stage' }, [
        el('div', { class: 'fg-sp__zoom' }, [
          btn('−', 'fg-sp__round', function () { S.zoom = Math.max(0.4, S.zoom - 0.15); render(); }, { 'aria-label': 'Verkleinern' }),
          btn('+', 'fg-sp__round', function () { S.zoom = Math.min(1.6, S.zoom + 0.15); render(); }, { 'aria-label': 'Vergrößern' }),
          btn('Alles zeigen', 'fg-sp__chip', function () { fitZoom(0.25); })
        ]),
        renderFloor()
      ]),
      el('div', { class: 'fg-sp__bar' }, [
        el('div', { class: 'fg-sp__spacer' }),
        S.step === 'arrange'
          ? btn('Weiter zu den Gästen', 'fg-sp__btn fg-sp__btn--dark', function () { S.step = 'seating'; S.moveArmed = false; commit(); })
          : btn('Sitzplan sichern', 'fg-sp__btn fg-sp__btn--dark', function () { S.exportOpen = true; FG.track('sitzplan_export_open', {}); render(); })
      ])
    ]);

    return el('div', { class: 'fg-sp__layout' }, [main, renderSidePanel()]);
  }

  /* Dos minimos distintos a proposito: al entrar y al redimensionar se busca
     un tamano legible (0.45), aunque haya que hacer scroll. "Alles zeigen" es
     una vista general y ahi si se permite bajar hasta 0.25, porque el boton
     promete ensenar el plano entero. */
  function fitZoom(min) {
    var stage = root.querySelector('.fg-sp__stage');
    if (!stage) return;
    var lo = min || 0.45;
    S.zoom = Math.max(lo, Math.min(1.6, (stage.clientWidth - 24) / S.floorW));
    render();
  }

  function renderHeader() {
    var steps = [
      { id: 'setup', num: '1', label: 'Eckdaten' },
      { id: 'arrange', num: '2', label: 'Anordnung' },
      { id: 'seating', num: '3', label: 'Sitzplätze' }
    ];
    var done = S.tables.length > 0;
    return el('header', { class: 'fg-sp__header' }, [
      el('div', { class: 'fg-sp__header-row' }, [
        el('a', { class: 'fg-sp__brand', href: '/', text: 'Festegiatu' }),
        el('span', { class: 'fg-sp__tag', text: 'Tischplaner' }),
        el('div', { class: 'fg-sp__spacer' }),
        el('span', { class: 'fg-sp__muted', text: S.tables.length ? (S.tables.length + ' Tische · ' + capacity() + ' Plätze') : 'Kostenlos, ohne Konto' })
      ]),
      el('div', { class: 'fg-sp__steps' }, steps.map(function (st) {
        var on = S.step === st.id;
        return el('button', {
          type: 'button', class: 'fg-sp__step' + (on ? ' is-on' : ''),
          disabled: (!done && st.id !== 'setup') ? 'disabled' : null,
          onclick: function () { if (!done && st.id !== 'setup') return; S.step = st.id; S.moveArmed = false; commit(); }
        }, [
          el('span', { class: 'fg-sp__step-num', text: st.num }),
          el('span', { text: st.label })
        ]);
      }))
    ]);
  }

  function renderMobileBar() {
    if (S.step !== 'seating') return null;
    var p = pool();
    return el('div', { class: 'fg-sp__mobilebar' }, [
      el('div', { class: 'fg-sp__mobilepool' }, p.map(function (g) {
        return el('button', {
          type: 'button', class: 'fg-sp__chip fg-sp__chip--guest' + (S.picked === g.id ? ' is-on' : ''),
          text: g.name,
          onclick: function () { S.picked = S.picked === g.id ? null : g.id; render(); }
        });
      })),
      btn('Sichern', 'fg-sp__btn fg-sp__btn--dark', function () { S.exportOpen = true; render(); })
    ]);
  }

  function render() {
    root.innerHTML = '';
    root.appendChild(renderHeader());
    if (S.step !== 'setup') root.appendChild(renderPrintHead());
    var main = el('main', { class: 'fg-sp__main' }, [S.step === 'setup' ? renderSetup() : renderPlan()]);
    root.appendChild(main);
    var bar = renderMobileBar();
    if (bar) root.appendChild(bar);
    if (S.step !== 'setup') {
      var plist = renderPrintList();
      if (plist) root.appendChild(plist);
    }
    var modal = renderExport();
    if (modal) root.appendChild(modal);
    var pmodal = renderPrint();
    if (pmodal) root.appendChild(pmodal);
  }

  /* ------------------------------------------------------------------ init */

  S = load();
  if (S.step !== 'setup' && !S.tables.length) S.step = 'setup';

  /* 14.09.2026: si venimos de un envio de email recien hecho (la pagina se
     recargo tras el POST del formulario nativo), se marca el email como
     capturado, se cierra el modal de email y se abre directamente el de
     impresion, con la confirmacion. Solo tiene sentido si ya hay un plan
     hecho; si por lo que sea no lo hay, se ignora. */
  if (window.FG_LEAD_POSTED && S.tables.length) {
    FG.leadCaptured.set(true);
    FG.consent.set(true);
    S.exportOpen = false;
    S.printOpen = true;
    S.justConfirmed = true;
  }

  render();
  if (S.step !== 'setup') fitZoom();

  window.addEventListener('resize', FG.debounce(function () {
    if (S.step !== 'setup') fitZoom();
  }, 300));

  /* El guardado normal va con debounce. Si cierran la pestana justo despues de
     un cambio, ese cambio se perderia: aqui se fuerza la escritura. */
  window.addEventListener('pagehide', writeNow);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') writeNow();
  });
})();
